import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common'
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { SpecificDanoneService } from 'src/app/assabil-sales/services/specific_danone_service';
import { Partnercluster } from 'src/app/assabil-sales/models/entities/partnercluster';



@Component({
  selector: 'sip-partner-list',
  templateUrl: './sip-partner-list.component.html',
  styleUrls: ['./sip-partner-list.component.scss']
})
export class SipPartnerListComponent extends BasePage2<Partnercluster> {

  
  @Input() periodActiveDay    : Date;
  @Input() subPeriodCode      : string;
  @Input() dnProductFamilyCode: string;
  @Input() dnProductFamilyName: string;
  @Input() geoAreaCode        : string;
  @Input() geoAreaName        : string;
  @Input() kpi                : string;
  @Input() dnPeriod           : string;

  // Filter fields
  // -------------------------------------------------------------------------------------

  // -------------------------------------------------------------------------------------
  sipPartners : any[] = [];
  // -------------------------------------------------------------------------------------

  title = "";
  // -------------------------------------------------------------------------------------

  
//--------------------------------------------------------------------------------------------------------

  constructor(
      protected datepipe: DatePipe,
      protected toastr            : ToastrService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected specificDanoneService    : SpecificDanoneService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = "sipPartner";
  }
//--------------------------------------------------------------------------------------------------------

  
//--------------------------------------------------------------------------------------------------------
  ngOnInit() {
    //assigner periodActiveDay !!!!
    
    if (! this.embeded) return;
    this.loadData();
    this.title = "Détails clients éxclus : Date : " + this.datepipe.transform(this.periodActiveDay, 'dd/MM/yyyy') + " | " + this.geoAreaName + " | Famille de produits :  " + this.dnProductFamilyName;
  }
//--------------------------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------------------------
getRows(): Partnercluster[] {
      return this.sipPartners;
  }
//--------------------------------------------------------------------------------------------------------



//--------------------------------------------------------------------------------------------------------
loadData() {
 
  if (this.kpi === "dnP1")
    this.subPeriodCode = "P1";

  if (this.kpi === "dnP2")
    this.subPeriodCode = "P2";
  
  if (this.kpi === "dnP3")
    this.subPeriodCode = "P3";
  
   this.specificDanoneService.danoneSipPartnersGet(this.periodActiveDay, this.dnProductFamilyCode, this.geoAreaCode).then(result => {
      this.sipPartners = result;
      console.log("rows ", this.sipPartners);
      console.log("listfields ", this.listFields);
    })
}
//--------------------------------------------------------------------------------------------------------

selectedPartner() {
  console.log("test")
}

}

